var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGasStove = function SvgGasStove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gas-stove_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#gas-stove_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 2,
    y: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 8,
    y: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 6.5,
    y: 5.5,
    rx: 0.5,
    transform: "rotate(90 6.5 5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 6.5,
    y: 11.5,
    rx: 0.5,
    transform: "rotate(90 6.5 11.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 16,
    y: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 14.5,
    y: 5.5,
    rx: 0.5,
    transform: "rotate(90 14.5 5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 14.5,
    y: 11.5,
    rx: 0.5,
    transform: "rotate(90 14.5 11.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 14.5,
    y: 5.5,
    rx: 0.5,
    transform: "rotate(90 14.5 5.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 14.5,
    y: 11.5,
    rx: 0.5,
    transform: "rotate(90 14.5 11.5)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 19,
    x: 19.5,
    y: 3.5,
    stroke: "currentColor",
    rx: 1.5,
    transform: "rotate(90 19.5 3.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 8.5,
    y: 7,
    stroke: "currentColor",
    rx: 2.5,
    transform: "rotate(90 8.5 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    x: 16.5,
    y: 7,
    stroke: "currentColor",
    rx: 2.5,
    transform: "rotate(90 16.5 7)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gas-stove_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gas-stove_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 20,
    x: 20,
    y: 3,
    fill: "#fff",
    rx: 2,
    transform: "rotate(90 20 3)"
  })))));
};
export default SvgGasStove;